<div class="aza-horizontal-stack multi-registration__header">
    <div class="multi-registration__header__title">
        {{ TRANSLATION_MAP.INVITE_PEOPLE | translate }}
    </div>
    <div
        class="multi-registration__header__info aza-flex-grow"
        [innerHTML]="
            TRANSLATION_MAP.INVITE_PEOPLE_INFO
                | translate : { count: state.max_slots }
                | apply : formSvc.getSanitizedHtml
        "
    ></div>
    <div
        *ngIf="
            state
                | apply
                    : formSvc.createAssignMainParticipantFieldData as fieldData
        "
        #headerAssignMainParticipantEl
        class="{{ attributeName.assignMainParticipantClassName }}"
    >
        <ng-container
            [ngTemplateOutlet]="fieldTemplate"
            [ngTemplateOutletContext]="{
                field: fieldData.field,
                participant: fieldData.data
            }"
        ></ng-container>
        {{
            fieldData.data.status
                | apply
                    : recallFillElementOnStatusChanges
                    : fieldData.data
                    : headerAssignMainParticipantEl
        }}
    </div>
    <div class="multi-registration__header__add-sub-participant">
        <button
            class="aza-button aza-flex-grow"
            (click)="showDraftSubParticipant()"
            [disabled]="!state.can_add_participant"
            [class.disabled]="!state.can_add_participant"
        >
            {{ TRANSLATION_MAP.INVITE_SUB_PARTICIPANTS | translate }}
        </button>
    </div>
</div>

<ng-container
    *ngIf="
        editedSubParticipantRecord()[state.main_participant.id] ||
        editedSubParticipantRecord()[
            attributeName.draftParticipantId
        ] as draftParticipant
    "
    class="multi-registration__new-participant"
>
    <div
        *ngIf="
            (draftParticipant.is_main &&
                !state.main_participant.ticket_type_id) ||
            draftParticipant.id === attributeName.draftParticipantId
        "
        class="multi-registration__new-participant aza-cmp-padding"
    >
        <ng-container
            [ngTemplateOutlet]="subParticipantForm"
            [ngTemplateOutletContext]="{ participant: draftParticipant }"
        >
        </ng-container>

        <ng-container
            *ngIf="
                !isRequireTicket &&
                draftParticipant.is_main &&
                draftParticipant.id
            "
        >
            <!-- Immediately save draft if its main_participant && multiregistration_type != 'ticket' -->
            {{ draftParticipant.id | apply : saveDraftAfterDelay }}
        </ng-container>
    </div>
</ng-container>

<aza-rws-multi-registration-form-table
    #tableEl
    [extraRowDivTemplate]="tableExtraRowDiv"
    [rowActionGetter]="tableRowActionGetter"
    [config]="config"
    [eventParticipant]="eventParticipant"
    [state]="state"
    [subParticipantFields]="subParticipantFields"
    [editedSubParticipantRecord]="editedSubParticipantRecord()"
></aza-rws-multi-registration-form-table>

<ng-template #tableExtraRowDiv let-row="row" let-isCardView="isCardView">
    <ng-container
        *ngIf="editedSubParticipantRecord()[row.object.id] as subParticipant"
    >
        <ng-container
            *ngIf="
                subParticipant.is_main
                    ? !!subParticipant.ticket_type_id
                    : subParticipant.id !== attributeName.draftParticipantId
            "
            [ngTemplateOutlet]="subParticipantForm"
            [ngTemplateOutletContext]="{
                participant: subParticipant,
                isTableRow: !isCardView
            }"
        ></ng-container>
    </ng-container>

    <ng-container
        *ngIf="
            !editedSubParticipantRecord()[row.object.id] &&
            row.object.ui_participant as subParticipant
        "
    >
        <ng-container *ngIf="subParticipant?.error?.message as error">
            <div
                class="{{!isCardView | apply : getVirtualTableRowCss}}"
            >
                <div *ngIf="isCardView" class="aza-field-validation-error aza-cmp-padding ">
                    {{ error }}
                </div>
                <td
                    *ngIf="!isCardView"
                    class="aza-field-validation-error aza-cmp-padding "
                    [attr.colspan]="tableEl.data$.value.columns.length + 1"
                >
                    {{ error }}
                </td>
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template
    #subParticipantForm
    let-participant="participant"
    let-isTableRow="isTableRow"
>
    <div
        class="{{
            isTableRow | apply : getVirtualTableRowCss
        }} aza-section-content aza-section-colors {{
            participant.is_main ? 'multi-registration__main-participant' : ''
        }} {{ attributeName.classNamePrefixSubParticipant }}{{
            participant.id
        }} {{ attributeName.classNamePrefixSubParticipant }}status-{{
            participant.status
        }}"
        [attr.sub-participant-id]="participant.id"
    >
        <ng-container *ngIf="participant as subParticipant">
            <ng-container *ngIf="isTableRow">
                <td class="aza-cmp-padding " [attr.colspan]="tableEl.data$.value.columns.length + 1">
                    <ng-container
                        [ngTemplateOutlet]="fieldAreaWrapperTemplate"
                    ></ng-container>
                </td>
            </ng-container>

            <ng-container *ngIf="!isTableRow">
                <ng-container
                    [ngTemplateOutlet]="fieldAreaWrapperTemplate"
                ></ng-container>
            </ng-container>

            <ng-template #fieldAreaWrapperTemplate>
                <div #fieldAreaWrapperEl class="aza-form-field-area-wrapper" [class.aza-cmp-padding]="!isTableRow">
                    <ng-container *ngIf="!subParticipant.is_main">
                        <ng-container
                            *ngFor="let field of subParticipantFields"
                            [ngTemplateOutlet]="fieldTemplate"
                            [ngTemplateOutletContext]="{
                                field:
                                    subParticipant.status
                                    | apply
                                        : getFieldWithParticipantStatus
                                        : field
                                        : subParticipant,
                                participant: subParticipant
                            }"
                        ></ng-container>
                    </ng-container>
                    <ng-container
                        *ngIf="
                            subParticipant
                                | apply
                                    : formSvc.createTicketField
                                    : (subParticipant.is_main
                                          ? true
                                          : undefined) as field
                        "
                        [ngTemplateOutlet]="ticketFieldTemplate"
                        [ngTemplateOutletContext]="{ field, participant: subParticipant}"
                    ></ng-container>
                    {{
                        subParticipant.status
                            | apply
                                : recallFillElementOnStatusChanges
                                : subParticipant
                                : fieldAreaWrapperEl
                    }}
                </div>
                <div class="aza-horizontal-stack justify-self-end">
                    <button
                        class="aza-button"
                        (click)="cancelDraft(subParticipant.id)"
                    >
                        {{ TRANSLATION_MAP.CLOSE | translate }}
                    </button>
                    <button
                        #addSubParticipantButtonEL
                        class="aza-button"
                        [disabled]="
                            getSaveSubParticipantDisabled(subParticipant.id)
                        "
                        [class.disabled]="
                            getSaveSubParticipantDisabled(subParticipant.id)
                        "
                        (click)="saveDraft(subParticipant.id)"
                    >
                        {{
                            (isTableRow
                                ? TRANSLATION_MAP.EDIT_SUB_PARTICIPANTS
                                : TRANSLATION_MAP.ADD_SUB_PARTICIPANTS
                            ) | translate
                        }}
                    </button>
                </div>
            </ng-template>
        </ng-container>
    </div>
</ng-template>

<ng-template
    #fieldTemplate
    let-field="field"
    let-participant="participant"
    let-validateFnName="validateFnName"
>
    <div
        class="aza-form-field-area"
        [attr.aza-input-lock-value]="field.editable ? null : true"
        [innerHtml]="
            null
                | apply
                    : formSvc.createInputFieldElement
                    : field
                    : participant
                    : validateFnName
        "
    ></div>
</ng-template>

<ng-template
    #ticketFieldTemplate
    let-field="field"
    let-participant="participant"
>
    <ng-container
        *ngIf="isRequireTicket"
        [ngTemplateOutlet]="fieldTemplate"
        [ngTemplateOutletContext]="{ field, participant, validateFnName: 'azavista.validateMultiRegistrationTicketField' }"
    ></ng-container>
</ng-template>
